import { Navigate } from 'react-router-dom';
import { Route, Routes } from 'react-router-dom';

import { useAuthState } from './hooks/useAuthState';
import { Layout } from './layout/Layout';
import { ChangeEmailPage } from './pages/ChangeEmailPage';
import { ChangePasswordPage } from './pages/ChangePasswordPage';
import { FullScreenLoader } from './pages/FullScreenLoader';
import { HomePage } from './pages/HomePage';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import { RemoveAccountPage } from './pages/RemoveAccountPage';
import { PromoCodePage } from './pages/PromoCodePage';

import OrganisationsList from './pages/organisations/OrganisationsList';
import CreateOrganisation from './pages/organisations/CreateOrganisation';
import EditOrganisation from './pages/organisations/EditOrganisation';
import UsersList from './pages/users/UsersList';

export const App = () => {
  const { user, loading } = useAuthState();

  return loading ? (
    <FullScreenLoader />
  ) : (
    <Layout>
      <Routes>
        <Route path='/' element={user ? <HomePage /> : <Navigate to='/login' replace />} />
        <Route path='/success' element={user ? <HomePage promo /> : <Navigate to='/login' replace />} />
        <Route path='/login' element={!user ? <LoginPage /> : <Navigate to='/' replace />} />
        <Route path='/register' element={<RegisterPage />} />
        <Route path='/password/reset' element={<ResetPasswordPage />} />
        <Route path='/password/change' element={user ? <ChangePasswordPage /> : <Navigate to='/login' replace />} />
        <Route path='/email/change' element={user ? <ChangeEmailPage /> : <Navigate to='/login' replace />} />
        <Route path='/account/remove' element={user ? <RemoveAccountPage /> : <Navigate to='/login' replace />} />
        <Route path='/promo' element={<PromoCodePage />} />
        <Route path='/orgs' element={<OrganisationsList />} />
        <Route path='/orgs/create' element={<CreateOrganisation />} />
        <Route path='/orgs/:orgId' element={<EditOrganisation />} />
        <Route path='/users' element={<UsersList />} />
      </Routes>
    </Layout>
  );
};
